import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { compose } from '@beef/redux';
import { isEmpty } from 'lodash';
import { getTariffParameters } from "../../../../store/blocks/tariffs/tariffSelectors";
import { TariffParameter } from "../TariffParameter";
export var _TariffParameters = function _TariffParameters(_ref) {
  var className = _ref.className,
    parameters = _ref.parameters;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "data-t-id": "components-TariffParameters"
  }, parameters.map(function (parameter) {
    return /*#__PURE__*/React.createElement(TariffParameter, _extends({
      key: parameter.text
    }, parameter));
  }));
};

// @ts-expect-error state not typed in ts yet
var mapStateToProps = function mapStateToProps(state) {
  return {
    parameters: getTariffParameters(state),
    shouldRender: !isEmpty(getTariffParameters(state))
  };
};
export var TariffParameters = compose(connect(mapStateToProps), withRenderFlag)(_TariffParameters);